import { db, FieldValue } from 'helpers/firebase';
import { ORG_STATUS } from 'constants/org';
import { ROLES } from 'constants/user';
const serverTimestamp = FieldValue.serverTimestamp


//CRUD
export const createOrg = (params) => {

  const {
    author_uid
  } = params;

  const batch = db.batch();
  const orgRef = db.collection('/orgs').doc();
  const authorRef = db.doc(`/users/${author_uid}`);

  batch.set(orgRef, {
    ...params,
    created_at: serverTimestamp(),
    modified_at: serverTimestamp(),
    status: ORG_STATUS.WAITING_FOR_REVIEW
  });

  const currentTS = +new Date();
  batch.update(authorRef, `orgs.${orgRef.id}`, currentTS);
  return batch.commit();
}

export const getOrg = (org_id) => {
  if (!org_id) {
    return Promise.reject('org_id is required');
  }

  const orgRef = db.doc(`/orgs/${org_id}`);
  return orgRef.get();
}

export const updateOrg = (org_id, params) => {
  if (!org_id) {
    return Promise.reject('org_id is required');
  }

  const orgRef = db.doc(`/orgs/${org_id}`);
  return orgRef.update(params);
}

export const deleteOrg = (org_id) => {
  if (!org_id) {
    return Promise.reject('org_id is required');
  }

  const orgRef = db.doc(`/orgs/${org_id}`);
  return orgRef.update({ status: ORG_STATUS.REMOVED });
}


//collection
export const getOrgs = (currentRole) => {
  if (!currentRole) {
    return Promise.reject('currentRole is required');
  }
  const { orgs = [], role } = currentRole;
  if (role === ROLES.SUPER_ADMIN || role === ROLES.ASSOCIATION_ADMIN) {
    const ref = db.collection('/orgs');
    return ref.get()
      .then(colSnap => colSnap.docs)
  } else {
    return Promise.all(orgs.map(org_id => getOrg(org_id)))
  }
}

export const getAllOrgsCount = () => {
  const ref = db.collection('/orgs');
  return ref.get().then(colSnap => colSnap.count);
}